import { useContext } from "react";

import { AppConfigContext } from "./app-config-context";

export const useAppConfig = (): AppConfigContext =>
  useContext(AppConfigContext);
